export const Role = {
    Admin: 'admin',
    Operator: 'operator',
    Marketing: 'marketing',
    MarketingGuest: 'marketing_guest'
}

export const checkRole = (roles, allowedRoles) => {
    if (roles == null)
        return false;

    if (!roles.hasOwnProperty('pickup') || !roles['pickup'])
        return false;

    let isAllowed = false;
    window.console.log("roles: ", JSON.stringify(allowedRoles));
    allowedRoles.forEach(role => {
        window.console.log("role is", role);
        if (roles.hasOwnProperty(role) && roles[role]) {
            window.console.log("role is OK");
            isAllowed = true;
        }
    });

    return isAllowed;
};


export const getRole = (roles) => {
    if (!roles.hasOwnProperty('pickup') || !roles['pickup'])
        return '';

    if (roles.hasOwnProperty(Role.Admin) && roles[Role.Admin])
        return Role.Admin;

    if (roles.hasOwnProperty(Role.MarketingGuest) && roles[Role.MarketingGuest])
        return Role.MarketingGuest;

    if (roles.hasOwnProperty(Role.Operator) && roles[Role.Operator])
        return Role.Operator;

    if (roles.hasOwnProperty(Role.Marketing) && roles[Role.Marketing])
        return Role.Marketing;

    return '';
}
